import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import type { LifecycleWatchSubstatus } from '@/constants/lifecycleStages';
import { MAINTENANCE_PROJECTS_KEY, MAINTENANCE_STATS_KEY } from '@/lib/queryKeys/maintenanceKeys';

interface Args {
  projectId: string;
  value: LifecycleWatchSubstatus | null;
}

const isRlsError = (err: any): boolean => {
  const msg = (err?.message || '').toLowerCase();
  return (
    err?.code === '42501' ||
    msg.includes('row-level security') ||
    msg.includes('permission denied') ||
    msg.includes('insufficient_privilege')
  );
};

export const useUpdateWatchSubstatus = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ projectId, value }: Args) => {
      const { error } = await supabase
        .from('projects')
        .update({ watch_substatus: value } as any)
        .eq('id', projectId);
      if (error) throw error;
    },
    onSuccess: (_d, { projectId }) => {
      qc.invalidateQueries({ queryKey: ['project', projectId] });
      qc.invalidateQueries({ queryKey: ['project-edit', projectId] });
      qc.invalidateQueries({ queryKey: ['project-detail', projectId] });
      // Mirror build hook: invalidate ALL projects-optimized-v2 pages/filters
      qc.invalidateQueries({
        queryKey: ['projects-optimized-v2'],
        exact: false,
        refetchType: 'active',
      });
      qc.invalidateQueries({
        queryKey: [MAINTENANCE_PROJECTS_KEY],
        exact: false,
        refetchType: 'active',
      });
      qc.invalidateQueries({
        queryKey: [MAINTENANCE_PROJECTS_KEY],
        exact: false,
        refetchType: 'active',
      });
      qc.invalidateQueries({ queryKey: ['projects', 'status-stats'], exact: false });
      qc.invalidateQueries({
        queryKey: [MAINTENANCE_STATS_KEY],
        exact: false,
        refetchType: 'active',
      });
      toast.success('Đã cập nhật trạng thái theo dõi');
    },
    onError: (err: any) => {
      if (isRlsError(err)) toast.error('Bạn không có quyền sửa trạng thái theo dõi');
      else toast.error(err?.message || 'Cập nhật trạng thái theo dõi thất bại');
    },
  });
};
